module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "ql-bookmark-type-icon",
    class: ("ql-bookmark-type-icon--" + _vm.resolvedType),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "2.5 1.5 13 15.5",
      "fill": "none",
      "aria-label": _vm.ariaLabel
    }
  }, [(_vm.ariaLabel) ? _c('title', [_vm._v(_vm._s(_vm.ariaLabel))]) : _vm._e(), _vm._v(" "), _c('path', {
    staticClass: "ql-bookmark-type-icon__ribbon",
    attrs: {
      "d": "M14.2 16.5L9 12.85 3.8 16.5V4.2A1.6 1.6 0 0 1 5.4 2.6h7.2A1.6 1.6 0 0 1 14.2 4.2v12.3z",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), (_vm.resolvedType === 'act') ? _c('text', {
    staticClass: "ql-bookmark-type-icon__glyph",
    attrs: {
      "x": "9",
      "y": "8.9",
      "text-anchor": "middle",
      "dominant-baseline": "middle",
      "font-family": "'Syncopate', sans-serif",
      "font-size": "4.3",
      "font-weight": "400",
      "font-style": "normal",
      "fill": "currentColor"
    }
  }, [_vm._v("A")]) : (_vm.resolvedType === 'scene') ? _c('text', {
    staticClass: "ql-bookmark-type-icon__glyph",
    attrs: {
      "x": "9",
      "y": "8.9",
      "text-anchor": "middle",
      "dominant-baseline": "middle",
      "font-family": "'Syncopate', sans-serif",
      "font-size": "4.3",
      "font-weight": "400",
      "font-style": "normal",
      "fill": "currentColor"
    }
  }, [_vm._v("S")]) : _c('path', {
    staticClass: "ql-bookmark-type-icon__glyph",
    attrs: {
      "fill": "currentColor",
      "transform": "translate(9 8.6) scale(0.68) translate(-9 -8.6)",
      "d": "M9.4 5.15v4.9c-.36-.2-.78-.3-1.2-.3-1.2 0-2.15.82-2.15 1.8s.95 1.8 2.15 1.8 2.15-.82 2.15-1.8V7.25h2V5.15H9.4z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57a776ea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/bookmark/bookmark-type-icon.vue
// module id = 1246
// module chunks = 21